module.exports = __webpack_public_path__ + "img/BancosParticipantes.7d1a8b5d.png";